// extracted by mini-css-extract-plugin
module.exports = {"base":"src-ModalWindow-base-2dbdacf4"};